import { render } from "./ylyPLPromotionAndProduct.vue?vue&type=template&id=799618c2&scoped=true"
import script from "./ylyPLPromotionAndProduct.vue?vue&type=script&lang=js"
export * from "./ylyPLPromotionAndProduct.vue?vue&type=script&lang=js"

import "./ylyPLPromotionAndProduct.vue?vue&type=style&index=0&id=799618c2&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799618c2"]])

export default __exports__